import { createSlice } from "@reduxjs/toolkit";

// Create a slice of the Redux store
export const SelectedChat = createSlice({
  name: "selectedChat", // Name of the slice
  initialState: {
    selectedChat: null, // Initial state of the slice
  },
  reducers: {
    // Reducer to set the selected chat
    setSelectedChat: (state, action) => {
      state.selectedChat = action.payload; // Update state with payload
    },
  },
});

// Export the action to be used in components
export const { setSelectedChat } = SelectedChat.actions;

// Export the reducer to be used in the store
export default SelectedChat.reducer;
